<template>
  <div class="space-y-2">
    <!-- AI 提示词助手 -->
    <div class="border border-indigo-100 rounded bg-indigo-50/50">
      <button type="button" @click="showAI = !showAI"
        class="w-full flex items-center justify-between px-2 py-1.5 text-[11px] font-medium text-indigo-700">
        <span>🤖 AI 提示词助手（生成可对接后端的 HTML）</span>
        <span class="text-indigo-400">{{ showAI ? '收起' : '展开' }}</span>
      </button>
      <div v-if="showAI" class="px-2 pb-2 space-y-2">
        <p class="text-[10px] text-indigo-500 leading-relaxed">下方各模块的「复制提示词」已自动包含此后端说明，可直接整段发给 AI；若要生成整页，可单独复制此说明。</p>
        <div class="flex items-start gap-2 p-1.5 bg-white rounded border border-indigo-100">
          <p class="flex-1 text-[10px] text-gray-500 leading-relaxed whitespace-pre-wrap">{{ ctxDoc }}</p>
          <button type="button" @click="copy(ctxDoc, 'ctx')"
            class="flex-shrink-0 text-[10px] px-1.5 py-0.5 rounded bg-indigo-600 text-white hover:bg-indigo-700">{{ copied==='ctx' ? '已复制' : '复制' }}</button>
        </div>
        <div v-for="(sec, i) in sections" :key="i" class="bg-white rounded border border-indigo-100 p-1.5">
          <div class="flex items-center justify-between mb-1">
            <span class="text-[11px] font-semibold text-gray-700">{{ sec.title }}</span>
            <div class="flex gap-1">
              <button type="button" @click="copy(ctxDoc + '\n\n' + sec.prompt, 'p'+i)"
                class="text-[10px] px-1.5 py-0.5 rounded bg-indigo-600 text-white hover:bg-indigo-700">{{ copied==='p'+i ? '已复制' : '复制提示词' }}</button>
              <button type="button" @click="copy(sec.template, 't'+i)"
                class="text-[10px] px-1.5 py-0.5 rounded bg-gray-600 text-white hover:bg-gray-700">{{ copied==='t'+i ? '已复制' : '复制模板' }}</button>
            </div>
          </div>
          <p class="text-[10px] text-gray-400 leading-relaxed line-clamp-2">{{ sec.prompt }}</p>
        </div>
      </div>
    </div>
    <!-- HTML 内容 -->
    <div><ConfigHelpLabel label="HTML 内容" help-key="block_richtext_html" label-class="text-[10px] text-gray-500" tag="div" /><textarea v-model="block.data.html" @input="$emit('update')" rows="5" class="w-full px-2 py-1 border border-gray-300 rounded text-xs font-mono" placeholder="<p>支持 HTML 标签</p>"></textarea></div>
  </div>
</template>
<script setup>
import { onMounted, ref, computed } from 'vue'
import { useToast } from 'vue-toastification'
import { QR_CTX_DOC, AI_PROMPT_SECTIONS, QR_CTX_DOC_P2, AI_PROMPT_SECTIONS_P2 } from '../aiPrompts'
import ConfigHelpLabel from '../ConfigHelpLabel.vue'
const props = defineProps({ block: Object, langContent: Object, pageId: [Number, String], page: { type: [Number, String], default: 1 } })
defineEmits(['update'])
const toast = useToast()
const showAI = ref(false)
const copied = ref('')
const isP2 = computed(() => String(props.page) === '2')
const ctxDoc = computed(() => isP2.value ? QR_CTX_DOC_P2 : QR_CTX_DOC)
const sections = computed(() => isP2.value ? AI_PROMPT_SECTIONS_P2 : AI_PROMPT_SECTIONS)
const copy = async (text, key) => {
  try {
    await navigator.clipboard.writeText(text)
    copied.value = key
    toast.success('已复制到剪贴板')
    setTimeout(() => { if (copied.value === key) copied.value = '' }, 1500)
  } catch (e) { toast.error('复制失败') }
}
onMounted(() => { if (!props.block.data) props.block.data = {} })
</script>

